export default __webpack_public_path__ + "static/media/Platformpolygon.e39d0775.svg";